module.exports = __webpack_public_path__ + "img/jhPageJimeng3.f2ae7b52.png";